import { default as api } from 'config/authApiConf.js';

export const listCareerCategoryService = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-career-category?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
